import script from "./PropProvide.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PropProvide.vue?vue&type=script&setup=true&lang=js"
export * from "./PropProvide.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PropProvide.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__